import { MenuItem, Select } from "@mui/material";

/**
 * The asset/stock picker a themed card carries in its header -- the Keep,
 * Protect and Diversify cards each switch which asset their figures are read
 * for with one. Rendered by the caller only when there is something to pick.
 */
const HeaderAssetSelect = ({
  value,
  options,
  onChange,
}: {
  value: string;
  options: string[];
  onChange: (option: string) => void;
}) => (
  <Select
    size="small"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    sx={{ bgcolor: "background.paper" }}
  >
    {options.map((option) => (
      <MenuItem key={option} value={option}>
        {option}
      </MenuItem>
    ))}
  </Select>
);

export default HeaderAssetSelect;
